import * as R from 'ramda';
import { createSelector } from 'reselect';
import { getConfig } from '@components/config/selectors';

export const getEntityDetailsTrayConfig = createSelector([getConfig], configData => R.pathOr([], ['detailTrayConfig'], configData));
